module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Star-bc09436712203dbea763a944c9922f84.svg";